/* eslint-disable import/prefer-default-export */
export const UPDATE_ALL_PRODUCTS = 'UPDATE_ALL_PRODUCTS';
export const UPDATE_SELF_MANAGED_PRODUCTS = 'UPDATE_SELF_MANAGED_PRODUCTS';
export const UPDATE_PRODUCT_CATEGORIES = 'UPDATE_PRODUCT_CATEGORIES';
export const UPDATE_INVESTMENT_APPROACHES = 'UPDATE_INVESTMENT_APPROACHES';
export const UPDATE_ALL_TRANSACTIONS = 'UPDATE_ALL_TRANSACTIONS';
export const UPDATE_ALL_WITHDRAWAL_TRANSACTIONS = 'UPDATE_ALL_WITHDRAWAL_TRANSACTIONS';
export const UPDATE_ALL_USER_PRODUCTS = 'UPDATE_ALL_USER_PRODUCTS';
export const UPDATE_ALL_GROUP_PRODUCTS = 'UPDATE_ALL_GROUP_PRODUCTS';
export const UPDATE_ALL_GROUP_MEMBERS = 'UPDATE_ALL_GROUP_MEMBERS';
export const UPDATE_ALL_USER_FUDED_AND_UNFUNDED_PRODUCTS = 'UPDATE_ALL_USER_FUDED_AND_UNFUNDED_PRODUCTS';
export const UPDATE_ALL_USER_FUDED_PRODUCTS = 'UPDATE_ALL_USER_FUDED_PRODUCTS';
export const UPDATE_ALL_USER_UNFUDED_PRODUCTS = 'UPDATE_ALL_USER_UNFUDED_PRODUCTS';
export const UPDATE_PRODUCTS_EARNINGS = 'UPDATE_PRODUCTS_EARNINGS';
